var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-progress-circular"},[_c('div',{staticClass:"circular-progress"})])
}]

export { render, staticRenderFns }